import { FormInstance } from 'antd';

export const createPerTypeHandlers = (form: FormInstance) => {
  const handlePerTypeCashChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    const cashValue = Number(e.target?.value || e) ?? 0;
    const checkValue = 100 - cashValue;
    form.setFieldsValue({
      perTypeCheck: checkValue,
    });
  };

  const handlePerTypeCheckChange = (e: React.ChangeEvent<HTMLInputElement> | any) => {
    const checkValue = Number(e.target?.value || e) ?? 0;
    const cashValue = 100 - checkValue;
    form.setFieldsValue({
      perTypeCash: cashValue,
    });
  };

  return {
    handlePerTypeCashChange,
    handlePerTypeCheckChange,
  };
}; 